import type { SxProps, Theme } from "@mui/material/styles";

export const page: SxProps<Theme> = {
  px: { xs: 2, md: 4 },
  py: 4,
  maxWidth: 1200,
  mx: "auto",
};

export const title: SxProps<Theme> = {
  mb: 4,
  fontWeight: 800,
};

export const section: SxProps<Theme> = {
  mb: 5,
  p: 3,
  borderRadius: 3,
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
};

export const sectionTitle: SxProps<Theme> = {
  mb: 2.5,
  fontWeight: 700,
};

export const row: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(2),
  alignItems: "center",
});

export const column: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  width: "100%",
  maxWidth: 400,
});

export const badgeRow: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1.5),
  alignItems: "center",
});

export const referenceImage: SxProps<Theme> = {
  width: "100%",
  maxWidth: 900,
  borderRadius: 2,
  border: 1,
  borderColor: "divider",
};
